/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { transparent } = colors;

// Sửa so với bản gốc Material Dashboard 2:
//  - Bản gốc đặt `padding: 0 12px !important`, tức BỎ padding dọc, trong khi ô nhập outlined dùng
//    12px đều bốn phía (inputOutlined.js). Hậu quả: mọi ô chọn thấp hơn hẳn ô nhập đứng cạnh nó.
//    Vì bản gốc có `!important`, không `sx` nào ở phía component đè lại được — phải sửa ở đây.
//  - Bản gốc đặt `icon: { display: "none" }`, làm mất mũi tên xổ xuống nên ô chọn nhìn như ô nhập.
// Chừa sẵn 32px bên phải để chữ không chạy vào dưới mũi tên.
const select = {
  styleOverrides: {
    select: {
      display: "grid",
      alignItems: "center",
      padding: `${pxToRem(12)} ${pxToRem(32)} ${pxToRem(12)} ${pxToRem(12)} !important`,

      "&.MuiInputBase-inputSizeSmall": {
        padding: `${pxToRem(10)} ${pxToRem(32)} ${pxToRem(10)} ${pxToRem(12)} !important`,
      },

      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    icon: {
      right: pxToRem(8),
    },
  },
};

export default select;
